<template>
  <div class="cashbox-index">
    <cashbox-list/>
  </div>
</template>

<script>
  import CashboxList from './Cashbox.List'

  export default {
    components: { CashboxList }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/vue/app/cashbox/index/Cashbox.Index.vue